import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["options", "className", "onChange", "selectedOption", "placeholderText", "showPlaceholder", "disabled"];
import React from 'react';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import { wrap } from '@unmapped/core/utils';
import clsx from 'clsx';
export var Select = wrap((_ref, ref) => {
  var {
      options,
      className,
      onChange,
      selectedOption,
      placeholderText = 'Select...',
      showPlaceholder = true,
      disabled = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyleOverride('controls/Select', baseStyles);
  var value = selectedOption ? selectedOption : showPlaceholder ? '__PLACEHOLDER__' : '';
  return /*#__PURE__*/React.createElement("select", _extends({
    className: clsx(styles.Select, className),
    ref: ref
  }, rest, {
    disabled: disabled,
    value: value,
    onChange: onChange ? e => {
      var i = 0;
      var _loop = function _loop(opt) {
        if (opt.selected) {
          if (showPlaceholder && i === 0) onChange(null, e);else if (opt.value !== selectedOption && options.find(o => o.value === opt.value)) {
            onChange(opt.value, e);
          }
        }
        i++;
      };
      for (var opt of Array.from(e.target.options)) {
        _loop(opt);
      }
    } : undefined
  }), showPlaceholder && /*#__PURE__*/React.createElement("option", {
    value: "__PLACEHOLDER__"
  }, placeholderText), options.map((opt, i) => /*#__PURE__*/React.createElement("option", {
    value: opt.value,
    key: i
  }, opt.label)));
}, 'Select');
export default Select;
//# sourceMappingURL=index.js.map